import React, {useEffect, useState} from 'react';
import query from '../utils/query'

const Authcode = ({setCode}) => {
  const location = query();
  const [mounted, setMount] = useState(false);

  useEffect(() => {
    if(!mounted) {
      if(location.get('code')) {
        setCode(location.get('code'))
        setMount(true)
      } 
      setMount(true)
    }
  }, [mounted, location, setCode])
  return (
    <div></div>
  )
}

export default Authcode